import { Box, Typography, alpha } from '@mui/material';
import { ArticleSection } from 'types/blog';

// ==============================|| 目次 ||============================== //
//
// 記事データの章(ArticleSection)から自動で作る。章を足せば目次にも勝手に載るため、
// 目次を書き忘れることがない。
//
// リンクは react-router の Link ではなく素の <a href="#id"> にしている。
// 同一ページ内のアンカーはブラウザがそのまま処理するので、ルーターを通す必要がない。
// (通してしまうと、ページを描き直したうえで位置を復元する動きになり、かえって遅い)
//
// 飛び先で見出しが画面の最上部に貼りつかないよう、章側に scrollMarginTop を入れている
// (sections/blog/ArticleBody.tsx)。

const primaryColor = '#2aa1af';

const TableOfContents = ({ sections }: { sections: ArticleSection[] }) => (
    <Box
        component="nav"
        aria-label="目次"
        sx={{
            mt: { xs: 5, md: 6 },
            p: { xs: 2.5, md: 3.5 },
            borderRadius: 3,
            border: `1px solid ${alpha(primaryColor, 0.25)}`,
            bgcolor: alpha(primaryColor, 0.04)
        }}
    >
        <Typography component="p" sx={{ fontWeight: 900, fontSize: '1rem', color: '#0f3d43', mb: 2 }}>
            目次
        </Typography>
        <Box component="ol" sx={{ m: 0, pl: 0, listStyle: 'none', counterReset: 'toc' }}>
            {sections.map((section) => (
                <Box
                    component="li"
                    key={section.id}
                    sx={{
                        position: 'relative',
                        pl: 4,
                        mb: 1.25,
                        '&:last-of-type': { mb: 0 },
                        '&::before': {
                            counterIncrement: 'toc',
                            content: 'counter(toc)',
                            position: 'absolute',
                            left: 0,
                            top: '0.15em',
                            width: 22,
                            height: 22,
                            borderRadius: '50%',
                            border: `1.5px solid ${primaryColor}`,
                            color: primaryColor,
                            fontSize: '0.7rem',
                            fontWeight: 800,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: 1
                        }
                    }}
                >
                    <Box
                        component="a"
                        href={`#${section.id}`}
                        sx={{
                            color: '#374151',
                            fontSize: { xs: '0.92rem', md: '0.96rem' },
                            fontWeight: 600,
                            lineHeight: 1.75,
                            textDecoration: 'none',
                            '&:hover': { color: primaryColor, textDecoration: 'underline' }
                        }}
                    >
                        {section.heading}
                    </Box>
                </Box>
            ))}
        </Box>
    </Box>
);

export default TableOfContents;
